'use client'

import Link from 'next/link'

import { QRCode } from '@/app/components/QRCode'
import { useSettings } from '@/app/providers/SettingsProvider'
import DownloadAppStore from '@/public/images/downloadAppStore.svg'
import DownloadGooglePlay from '@/public/images/downloadGooglePlay.svg'

/**
 * DownloadArea component that displays QR codes for app download links from global settings.
 * This component doesn't have its own data - it uses settings data from the SettingsProvider.
 */
export default function DownloadArea() {
  const settings = useSettings()

  if (!settings?.appStoreUrl || !settings?.googlePlayUrl) {
    return null
  }

  return (
    <div className="content-container mx-auto -mt-10xl pt-2xl pb-4xl md:py-5xl lg:-mt-11xl lg:pb-11xl">
      <div className="flex flex-col md:gap-5xl">
        <div className="hidden md:flex md:items-center md:gap-2xl md:mx-auto">
          <div className="p-4xl bg-white rounded-xl">
            <QRCode url={settings.appStoreUrl} ariaLabel="Download App Store" />
            <p className="size-subheading-sm lg:size-subheading-lg text-center font-bold mt-xl mb-md lg:mt-4xl lg:mb-lg">
              Download for iOS
            </p>
            <p className="size-body-sm lg:size-body-lg text-center">From the App Store</p>
          </div>
          <div className="p-4xl bg-white rounded-xl">
            <QRCode url={settings.googlePlayUrl} ariaLabel="Download Google Play" />
            <p className="size-subheading-sm lg:size-subheading-lg text-center font-bold mt-xl mb-md lg:mt-4xl lg:mb-lg">
              Download for Android
            </p>
            <p className="size-body-sm lg:size-body-lg text-center">From Google Play</p>
          </div>
        </div>
        <div className="flex flex-col gap-md w-[124px] items-center mx-auto md:flex-row md:gap-2xl md:w-[334px] lg:hidden">
          {settings?.appStoreUrl && (
            <Link
              className="flex-1"
              href={settings.appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download App Store"
            >
              <DownloadAppStore className="h-auto w-full" />
            </Link>
          )}
          {settings?.googlePlayUrl && (
            <Link
              className="flex-1"
              href={settings.googlePlayUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download Google Play"
            >
              <DownloadGooglePlay className="h-auto w-full" />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
